const styles = theme => ({
  root: {
    alignItems: 'center',
    textAlign: 'center',
  },
  textField: {
    width: 'calc(100% - 48px)',
    marginRight: 12,
    marginTop: 36,
  },
  button: {
    marginTop: 14,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SearchByName/styles.js